// extracted by mini-css-extract-plugin
export var autocomplete = "style-module--autocomplete--f93a3";
export var hits = "style-module--hits--b56cb";
export var wrapper = "style-module--wrapper--80e78";